import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['slide', 'selector'];

  initialize() {
    this.showSlide(0);
  }

  connect() {
    this.startAutoplay(this.slideTargets[0].dataset.changeInterval);
  }

  disconnect() {
    this.stopAutoplay();
  }

  showSlide(index) {
    this.index = index;
    
    this.slideTargets.forEach((el, i) => {
      el.classList.toggle('shared--slider-current', index === i);
    });

    this.selectorTargets.forEach((el, i) => {
      el.classList.toggle('shared--slider__selector-active', index === i);
    })
  }

  changeSlide(event) {
    this.stopAutoplay();

    var index = parseInt(event.currentTarget.dataset.slideIndex);

    this.showSlide(index);

    this.startAutoplay(this.slideTargets[index].dataset.changeInterval);
  }

  next() {
    this.stopAutoplay();

    if (this.index + 1 === this.slideTargets.length) {
      this.index = -1;
    }

    this.showSlide(this.index + 1);

    this.startAutoplay(this.slideTargets[this.index].dataset.changeInterval);
  }

  previous() {
    this.stopAutoplay();

    if (this.index === 0) {
      this.index = this.slideTargets.length;
    }

    this.showSlide(this.index - 1);

    this.startAutoplay(this.slideTargets[this.index].dataset.changeInterval);
  }

  startAutoplay(interval) {
    if (interval) {
      this.changeTimer = setInterval(() => {
        this.next();
      }, interval);
    } else if (this.data.has('changeInterval')) {
      this.changeTimer = setInterval(() => {
        this.next();
      }, this.data.get('changeInterval'));
    }
  }

  stopAutoplay() {
    if (this.changeTimer) {
      clearInterval(this.changeTimer);
    }
  }
}
